<template>
  <div
    class="site-header-garage"
    :class="[
      `site-header-garage--${template}`,
      { [$class('active')]: activeVehicle && !garageLink },
    ]"
  >
    <button
      class="site-header-garage__inner"
      :class="{ 'icon-only': garageLink }"
      type="button"
      :aria-expanded="activeOverlay"
      aria-haspopup="dialog"
      @click="openFinderFlow('both')"
    >
      <icon-garage />

      <span
        v-if="garageLink"
        class="visually-hidden"
        v-text="$string('garage.open_garage')"
      />

      <template v-else>
        <span class="site-header-garage__label-container">
          <span
            v-if="activeVehicle"
            class="site-header-garage__active-label"
          >
            <span
              class="
                site-header-garage__garage
                text-body-xs-bold
                text-body-s-bold-desktop
              "
              v-text="garageString"
            />

            <span
              class="
                site-header-garage__vehicle
                text-body-xs-bold
                text-body-s-bold-desktop
              "
              v-text="activeVehicle.strings?.title"
            />
          </span>

          <span
            class="site-header-garage__inactive-label"
            :aria-hidden="Boolean(activeVehicle)"
          >
            <span
              class="
                site-header-garage__garage
                text-body-xs-bold
                text-body-s-bold-desktop
              "
              v-text="garageString"
            />

            <span
              class="
                site-header-garage__vehicle
                text-body-xs-regular
                text-body-s-regular-desktop
              "
              v-text="$string('garage.add_vehicle')"
            />
          </span>
        </span>

        <icon-chevron-right />
      </template>
    </button>

    <a
      v-if="garageLink"
      class="site-header-garage__inner link-only"
      :href="garageLink"
    >
      <span class="site-header-garage__label-container">
        <span class="site-header-garage__active-label">
          <span
            class="
              site-header-garage__garage
              text-body-xs-bold
              text-body-s-bold-desktop
            "
            v-text="$string('digital_hub.button.title')"
          />

          <span
            class="
              site-header-garage__subtitle
              text-body-xs-regular
              text-body-s-regular-desktop
            "
            v-text="$string('digital_hub.button.subtitle')"
          />
        </span>
      </span>

      <icon-chevron-right />
    </a>
  </div>
</template>

<script>

/**
 * Vue: Site header garage (site-header-garage)
 * -----------------------------------------------------------------------------
 * Garage button in site header to trigger vehicle finder modal.
 *
 * @param {String} [garageLink] - Use link instead of opening garage modal.
 * @param {String} template - Location of button, `mobile` or `desktop`.
 *
 */
import { mapActions, mapGetters } from 'vuex'

import IconGarage from '~icons/general/garage.svg'
import IconChevronRight from '~icons/directional-navigation/chevron/right.svg'

export default {
  name: 'SiteHeaderGarage',

  components: {
    IconGarage,
    IconChevronRight,
  },

  props: {
    garageLink: {
      type: String,
      default: '',
    },
    template: {
      type: String,
      default: 'mobile',
      required: true,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      activeVehicle: 'garage/getActiveVehicle',
      garageCount: 'garage/getGarageCount',
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Compute if related overlay is active.
     * @returns {Boolean}
     */
    activeOverlay() {
      return [
        'garageModal',
        'vehicleFinderModal',
      ].includes(this.getActiveOverlay?.namespace)
    },

    /**
     * Compute garage string.
     * @returns {String}
     */
    garageString() {
      return this.$string('garage.my_garage', {
        pluralise: this.garageCount,
        replace: { count: this.garageCount },
      })
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openFinderFlow: 'garage/openFinderFlow',
    }),
  },
}
</script>
